<script setup lang="ts">
import { reactive } from "vue";
import Container, {
  ContainerType,
  EffectTriggerTiming
} from "../Container.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Container },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    containerType?: ContainerType;
    supportCopyText?: boolean;
    effectTriggerTiming?: EffectTriggerTiming;
    color?: string;
    timeGap?: number;
    lineHeight?: number;
    location?: "underline" | "overline" | "through";
    direction?: "right" | "left" | "fromCenter";
  }>(),
  {
    containerType: "shrink",
    supportCopyText: true,
    effectTriggerTiming: "mouseMove",
    color: "#3cefff",
    timeGap: 50,
    lineHeight: 2,
    location: "underline",
    direction: "right"
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

let ratio = 1;
const resize = (controller) => {
  ratio = Math.ceil(
    Math.max(controller.rect.width, controller.rect.height) /
      Math.min(controller.rect.width, controller.rect.height)
  );
};

const style = reactive<Record<string, string>>({});
switch (props.location) {
  case "underline":
    style.bottom = "0";
    break;
  case "overline":
    style.top = "0";
    break;
  case "through":
    style.top = "50%";
    break;
}

const start = () => {
  switch (props.direction) {
    case "right":
      style.transformOrigin = "bottom right";
      style.transform = "scaleX(0)";
      break;
    case "left":
      style.transformOrigin = "bottom left";
      style.transform = "scaleX(0)";
      break;
    case "fromCenter":
      style.transformOrigin = "center";
      style.transform = "scaleX(0)";
      break;
  }
};
const end = () => {
  switch (props.direction) {
    case "right":
      style.transformOrigin = "bottom left";
      style.transform = "scaleX(1)";
      break;
    case "left":
      style.transformOrigin = "bottom right";
      style.transform = "scaleX(1)";
      break;
    case "fromCenter":
      style.transformOrigin = "center";
      style.transform = "scaleX(1)";
      break;
  }
};

defineExpose({});
</script>

<template>
  <Container
    :type="props.containerType"
    :supportCopyText="props.supportCopyText"
    :effectTriggerTiming="props.effectTriggerTiming"
    @start="start"
    @end="end"
    @ready="resize"
    @update="resize"
  >
    <div
      class="line-single-before"
      :style="{
        left: 0,
        width: '100%',
        height: props.lineHeight + 'px',
        backgroundColor: props.color,
        transition: `transform ${props.timeGap * ratio}ms ease-in-out`,
        ...style
      }"
    ></div>
    <div class="line-single">
      <slot></slot>
    </div>
  </Container>
</template>

<style scoped>
.line-single-before {
  position: absolute;
  z-index: 0;
}
.line-single {
  position: relative;
  z-index: 1;
  cursor: pointer;
}
</style>
